import * as React from "react";
import { CustomDateSvg } from "../../../../../../assets/icons/custom-svg-components/CompanySvgCollection";
import EventItemDateTime from "./EventItemDateTime";

interface EventItemStartDateTimeProps {
  startDate: Date;
  endDate: Date;
}

const EventItemStartDateTime: React.FC<EventItemStartDateTimeProps> = ({
  startDate,
  endDate,
}) => {
  const eventOnlyTakesPlaceOnOneDay =
    startDate.toDateString() === endDate.toDateString();
  return (
    <>
      {eventOnlyTakesPlaceOnOneDay ? (
        <>
          <CustomDateSvg /> {startDate.toLocaleDateString()}
        </>
      ) : (
        <>
          <CustomDateSvg /> {startDate.toLocaleDateString()}
          <EventItemDateTime date={startDate} />
        </>
      )}
    </>
  );
};

export default EventItemStartDateTime;
